import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import Table from "react-bootstrap/Table";
import { Spinner } from "react-bootstrap";
import CallIcon from "@mui/icons-material/Call";
import { Modal } from "react-bootstrap";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import { GrPrevious } from "react-icons/gr";
import { GrNext } from "react-icons/gr";
import "./show.css";
import Hexapi from "../utility/HexAPI/Hexapi";
import Swal from "sweetalert2";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import Urlencoder from "../utility/Urluncoder";
import { Aesdecryption } from "../utility/Aes/Aes";
import ScriptPreview from "./Scriptview";
import { MdDelete } from "react-icons/md";
import Followupdelete from "./Followupdelete";
import Reminder from "./Reminder";
import EditEnquiry from "./EditEnquiry";
import Followupinsert from "./Followupinsert";
import CallHistory from "./CallHistory";
import Userlist from "./Userlist";
import Usage from "./Usage";
import "../main.css";
import { FaEye } from "react-icons/fa";
import { ViewComponent } from "./attachment/ViewComponent";
import EditIcon from '@mui/icons-material/Edit';
import EditCandidateForm from "../pages/customerenquiry/EditCustomer";
import CustomerEnquiryform from "../pages/customerenquiry/customerEnquiry";


const ActionModal = forwardRef((props, ref) => {
  const {
    recid: recidProp,
    shortcutclose,
    modalshow,
    agentid,
    selectedRowIndex: selectedRowIndexProp,
    currentindex: currentindexProp,
    cidarray: cidarrayProp,
    processeddata: processeddataProp,
    refresh: refreshProp,
    isdisable,
    handleclosemodal,
    handlemodalclose,
    handlemodalshow,
    refreshtable,
    refreshtableset,
  } = props;


  const actionModalReqIdRef = useRef(0);
  const leadMasterReqIdRef = useRef(0);
  const leadMasterOrgReqIdRef = useRef(0);
  const chancesReqIdRef = useRef(0);


  const [recid, setRecid] = useState(recidProp);
  const [modalshoww] = useState(modalshow);
  const [agentID] = useState(agentid);
  const [labelupdate, setLabelupdate] = useState([]);
  const [isapihitcomplete, setIsapihitcomplete] = useState(false);
  const [found, setFound] = useState(false);
  const [isdatafound, setIsdatafound] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(selectedRowIndexProp);
  const [stageid, setStageid] = useState("");
  const [updatekeys, setUpdatekeys] = useState([]);
  const [updateheaderrow, setUpdateheaderrow] = useState([]);
  const [statusdata, setStatusdata] = useState(null);
  const [snewdata, setSnewdata] = useState("");
  const [chances, setChances] = useState("");
  const [orgdata, setOrgdata] = useState("");
  const [scriptdata, setScriptdata] = useState("");
  const [currentindex, setCurrentindex] = useState(currentindexProp);
  const [cidarray, setCidarray] = useState(cidarrayProp || []);
  const [openedFromToast, setOpenedFromToast] = useState(false);
  const [orgactionsmodal, setOrgactionsmodal] = useState(false);
  const [processeddata, setProcesseddata] = useState(processeddataProp || []);
  const [AgentList, setAgentList] = useState([]);
  const [calllistshow, setCalllistshow] = useState(false);
  const [isAPIcomplete, setIsAPIcomplete] = useState(false);
  const [Datafound, setDatafound] = useState(false);
  const [contactlist, setContactlist] = useState([]);
  const [calllink, setCalllink] = useState(null);
  const [leadwithID, setLeadwithID] = useState(0);
  const [productID, setProductID] = useState(0);
  const [stageprogress, setStageprogress] = useState([]);
  const [nextstep, setNextstep] = useState("");
  const [remark, setRemark] = useState("");
  const [editshow, setEditshow] = useState(false);
  const [iseditapihit, setIseditapihit] = useState(false);
  const [iseditdatafound, setIseditdatafound] = useState(false);
  const [Marketedby, setMarketedby] = useState("");
  const [contactnumber, setContactnumber] = useState("");
  const [registercontactnumber, setRegistercontactnumber] = useState("");
  const [designation, setDesignation] = useState("");
  const [officeaddress, setOfficeaddress] = useState("");
  const [leadsourceid, setLeadsourceid] = useState("");
  const [LeadSource, setLeadSource] = useState([]);
  const [productData, setProductData] = useState([
    { checked: false, qty: "", rate: "", total: "", productid: "", productname: "" },
  ]);
  const [machineusercount, setMachineusercount] = useState("");
  const [attendancemachine, setAttendancemachine] = useState("None");
  const [attendancemachinequality, setAttendancemachinequality] = useState("0");
  const [IncludeCards, setIncludeCards] = useState(false);
  const [contactid, setContactid] = useState(-1);
  const [isEditing, setIsEditing] = useState(false);
  const [callStatusOptions, setCallStatusOptions] = useState([]);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [updatefreetrialmodal, setUpdatefreetrialmodal] = useState(false);
  const [trackhrversionmodal, setTrackhrversionmodal] = useState(false);
  const [showmodalbutton, setShowmodalbutton] = useState(false);
  const [passwordtrackhrversion, setPasswordtrackhrversion] = useState("");
  const [freetrialdays, setFreetrialdays] = useState("");
  const [passwordfreetrial, setPasswordfreetrial] = useState("");
  const [addcontact, setAddcontact] = useState(false);
  const [showlockpassword, setShowlockpassword] = useState(false);
  const [editcontact, setEditcontact] = useState(false);
  const [refresh, setRefresh] = useState(refreshProp);
  const [scriptmodalopen, setScriptmodalopen] = useState(false);
  const [isfollowuploading, setIsfollowuploading] = useState(false);
  const [tempstage, setTempstage] = useState("");
  const [updateshow, setUpdateshow] = useState(false);
  const [isfollowdelete, setIsfollowdelete] = useState(false);
  const [followupdata, setFollowupdata] = useState(null);
  const [reminder, setReminder] = useState(0);
  const [expandfollowupmodal, setExpandfollowupmodal] = useState(false);
  const [call, setCall] = useState("");
  const [customerid, setCustomerid] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [attachment,setattachment]=useState(null)
  const [openattachment,setopenatachment]=useState(false)
  const recidRef = useRef(recid);
  const currentindexRef = useRef(currentindex);
  const cidarrayRef = useRef(cidarray);
  const processeddataRef = useRef(processeddata);
  const selectedRowIndexRef = useRef(selectedRowIndex);
  const[editmodalshow,seteditmodalshow]=useState(false)
  const refreshRef = useRef(refresh);

  useEffect(() => { recidRef.current = recid; }, [recid]);
  useEffect(() => { currentindexRef.current = currentindex; }, [currentindex]);
  useEffect(() => { cidarrayRef.current = cidarray; }, [cidarray]);
  useEffect(() => { processeddataRef.current = processeddata; }, [processeddata]);
  useEffect(() => { selectedRowIndexRef.current = selectedRowIndex; }, [selectedRowIndex]);
  useEffect(() => { refreshRef.current = refresh; }, [refresh]);


  const ActionModalFetch = (id) => {
    const reqId = ++actionModalReqIdRef.current;

    setIsapihitcomplete(false);
    setIsdatafound(false);
    setChances("");
    setUpdateheaderrow([]);
    setUpdatekeys([]);
    setSnewdata("");
    setScriptdata("");

    const obj = {
      query: `[dbo].[HCMS_Proc_ActionModal_GetData] @EnquiryID='{0}', @AgentID='{1}'`,
      queryArr: [`${id}`, `${agentID}`],
    };

    Hexapi(obj)
      .then((resp) => {
        if (reqId !== actionModalReqIdRef.current) return;

    console.log(resp,"fhgedjwbklmsa")

        if (resp?.followup?.length > 0) {
          const keys = Object.keys(resp.followup[0]);
          setUpdatekeys(keys);
          setUpdateheaderrow(resp.followup);
        }
if (resp?.[""]?.[0]) {
            setStageid(resp[""][0].stageid);
            setTempstage(resp[""][0].stageid);
            // setCall(resp[""][0].contactnumber);
            setIsdatafound(true);
            setStatusdata(resp[""][0].status);
          }
        if (resp?.priority?.[0]) {
          setSnewdata(resp.priority[0].s);
          setScriptdata(resp?.script?.[0]?.script ?? "");

          
        } else {
          setIsdatafound(false);
        }
      })
      .catch((err) => {
        if (reqId !== actionModalReqIdRef.current) return;
        console.error("ActionModal fetch error:", err);
        setIsdatafound(false);
      })
      .finally(() => {
        if (reqId === actionModalReqIdRef.current) {
          setIsapihitcomplete(true);
        }
      });
  };

  // const getchancesdata = async (id) => {
  //   const reqId = ++chancesReqIdRef.current;

  //   const obj = {
  //     query: `[HCMS_Proc_Enquiry_GetChances] @EnquiryID='{0}'`,
  //     queryArr: [`${id}`],
  //   };

  //   try {
  //     const resp = await Hexapi(obj);
  //     if (reqId !== chancesReqIdRef.current) return;
  //     if (resp?.[""]?.[0]) {
  //       setChances(resp[""][0].msg);
  //     }
  //   } catch (err) {
  //     if (reqId !== chancesReqIdRef.current) return;
  //     console.error("getchancesdata error:", err);
  //   }
  // };

const LeadMasterinfo = (id) => {
  const reqId = ++leadMasterReqIdRef.current;

  setFound(false);
  setLabelupdate([]);

  const obj = {
    query: `[dbo].[HCMS_Proc_LeadMasterInfo_GetData]@EnquiryID='{0}'`,
    queryArr: [`${id}`],
  };

  Hexapi(obj)
    .then((resp) => {
      console.log(resp, "respsppsbdcs");

      if (reqId !== leadMasterReqIdRef.current) return;

      const data = resp?.["leadmasterinfo"] || [];
const resumeid=resp?.["leadmasterinfo"]?.[0]?.resumeid?.trim()
if(resumeid && resumeid != null ){
  setattachment(resp?.["leadmasterinfo"]?.[0]?.resumeid)
}else{
  setattachment(null)
}
      const arr = [];

      for (let i = 0; i < data.length; i++) {
        const labelkeys = Object.keys(data[i]);

        for (let j = 0; j < labelkeys.length; j++) {
          const key = labelkeys[j];
          const value = data[i][key];

       
          if (key.toLowerCase() === "resumeid") continue;

          
          if (
            value === null ||
            value === undefined ||
            value === "" ||
            value.toString().trim() === "" || value == -1
          ) {
            continue;
          }

          arr.push({
            name: key,
            value: value,
          });
        }
      }

      console.log(arr, "arr");

      setLabelupdate(arr);
      setFound(true);
    })
    .catch((err) => {
      if (reqId !== leadMasterReqIdRef.current) return;

      console.error("LeadMasterinfo error:", err);
      setFound(true);
    });
};

 
  const refreshActionModal = (id) => {
    const idToUse = id ?? recidRef.current;
    ActionModalFetch(idToUse);
  
    LeadMasterinfo(idToUse);
    // getchancesdata(idToUse);
  };

  // ── componentDidMount ──────────────────────────────────────────────────────
  useEffect(() => {
    ActionModalFetch(recidProp);
  
    LeadMasterinfo(recidProp);
    // getchancesdata(recidProp);

    return () => {
    
    };

  }, []);


  const prevModalshowRef = useRef(modalshow);
  const prevRecidPropRef = useRef(recidProp);

  useEffect(() => {
    const prevModalshow = prevModalshowRef.current;
    const prevRecidProp = prevRecidPropRef.current;

    if (!prevModalshow && modalshow) {
      refreshActionModal(recidRef.current);
    }

    if (prevRecidProp !== recidProp) {
      setRecid(recidProp);
      recidRef.current = recidProp;
      setCurrentindex(0);
      currentindexRef.current = 0;
      refreshActionModal(recidProp);
    }

    prevModalshowRef.current = modalshow;
    prevRecidPropRef.current = recidProp;
  });

  // ── RemoveIndex ────────────────────────────────────────────────────────────
  const RemoveIndex = () => {
    if (isdisable || shortcutclose) return;

    const updatedCidArray = cidarrayRef.current.filter(
      (item) => item !== recidRef.current,
    );
    setCidarray(updatedCidArray);
    cidarrayRef.current = updatedCidArray;
    handleNext(updatedCidArray);
  };


  const handlefollowupdelete = (data) => {
    setIsfollowdelete(true);
    setFollowupdata(data);
  };

 
  const decodeUrl = (url) => {
    if (!url.includes("?")) return null;
    const encrypted = url.split("?")[1];
    const decrypted = atob(encrypted);
    if (!decrypted) return null;
    return Object.fromEntries(new URLSearchParams(decrypted));
  };

  
  const handleClose = () => {
    if (window.location.href.includes("?")) {
      const Data = decodeUrl(window.location.href);
      if (Data) {
        const url = window.location.href.split("?")[0];
        window.history.replaceState(null, "", url);
      }
      handleclosemodal();
      return;
    }
    if (shortcutclose) {
      handleclosemodal();
      return;
    }
    setOpenedFromToast(false);
    if (refreshRef.current == 1) {
      refreshtable(selectedRowIndexRef.current);
      return;
    }
    refreshtableset(selectedRowIndexRef.current);
    handlemodalclose();
  };

  const callnumber = async (e) => {
    setIsloading(true);
    try {
      const resp = await axios({ method: "GET", mode: "CORS", url: calllink });
      setIsloading(false);
      if (resp?.data) {
        Swal.fire({
          html: `<pre style="text-align:left;white-space:pre-wrap;">${JSON.stringify(resp.data, null, 2)}</pre>`,
          icon: "success",
          width: 600,
        });
      }
    } catch (error) {
      Swal.fire({ title: "Error", text: error.message, icon: "error" });
    }
  };

  // ── deleteEnquiry ──────────────────────────────────────────────────────────
  const deleteEnquiry = () => {
    confirmAlert({
      message: "Are you sure you want to Delete? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            const obj = {
              query: `[dbo].[HCMS_Proc_Enquiry_Delete] @EnquiryID='{0}'`,
              queryArr: [`${recidRef.current}`],
            };
            Hexapi(obj).then((resp) => {
              Swal.fire({ text: resp[""][0].msg }).then(() => {
                if (resp[""][0].command == "1") window.location.reload();
              });
            });
          },
        },
        { label: "No" },
      ],
      overlayClassName: "confirm__overlayClass",
    });
  };

  const handlePrevious = () => {
    const curIdx = currentindexRef.current;
    if (curIdx <= 0) return;

    const newIndex = curIdx - 1;
    const prevData = processeddataRef.current[newIndex];

    setRecid(cidarrayRef.current[newIndex]);
    recidRef.current = cidarrayRef.current[newIndex];
    setCustomerid(prevData.contactID);
    setStageid(prevData.stage);
    setCall(prevData.customerNumber);
    setCurrentindex(newIndex);
    currentindexRef.current = newIndex;
    setSelectedRowIndex((prev) => prev - 1);

    refreshActionModal(cidarrayRef.current[newIndex]);
  };

  
  const handleNext = (updatedCidArray) => {
    const arr = updatedCidArray ?? cidarrayRef.current;
    const curIdx = currentindexRef.current;

    if (curIdx >= arr.length - 1) return;

    const newIndex = curIdx + 1;
    const nextData = processeddataRef.current[newIndex];

    setRecid(arr[newIndex]);
    recidRef.current = arr[newIndex];
    setCustomerid(nextData.contactID);
    setStageid(nextData.stage);
    setCall(nextData.customerNumber);
    setCurrentindex(newIndex);
    currentindexRef.current = newIndex;
    setSelectedRowIndex((prev) => prev + 1);
    refreshActionModal(arr[newIndex]);
  };

  return (
    <div>
      {modalshow && (
        <Modal
          scrollable={true}
          show={modalshow}
          onHide={handleClose}
          keyboard={false}
          backdrop="static"
          style={{ backgroundColor: "rgba(0,0,0,0.9)" }}
          centered
          fullscreen
          size="lg"
        >
          <Modal.Header className="modal-header-action-modal" closeButton>
            <Modal.Title>Action</Modal.Title>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-around",
              }}
            >
              <Followupinsert
                EnquiryID={recid}
                StageID={stageid}
                agentID={agentID}
                refreshActionModal={() => {
                  setRefresh(1);
                  refreshRef.current = 1;
                  refreshActionModal(recidRef.current);
                }}
                RemoveIndex={() => RemoveIndex()}
              />
              {
                attachment &&<Tooltip title="View Attachment">
              <IconButton onClick={(e) => setopenatachment(true)}> 
                 <FaEye />
                </IconButton>
              </Tooltip>
              }
              
              <Reminder EnquiryID={recid} AgentID={agentID} />
              {/* <Tooltip title="Delete">
                <IconButton onClick={(e) => deleteEnquiry(e)}>
                  <DeleteForeverIcon />
                </IconButton>
              </Tooltip> */}
              {/* <Tooltip title="Edit">
        <IconButton
          onClick={() => {
            seteditmodalshow(true);
          }}
        >
          <EditIcon />
        </IconButton>
      </Tooltip> */}
            </div>
          </Modal.Header>

          <Modal.Body className="modal-body-action-modal">
            {isapihitcomplete && found ? (
               labelupdate.length > 0 ? (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="innertable">
                        <Table
                          responsive
                          className="table table-striped"
                          style={{ marginBottom: "20px" }}
                        >
                          <thead scope="row" style={{ whiteSpace: "nowrap" }}>
                            <tr
                              style={{
                                background: "rgb(18 80 172)",
                                color: "white",
                                position: "sticky",
                                top: "0px",
                              }}
                            >
                              {updatekeys.map((s, index) => {
                                if (s === "omit" || s === "followupid") return null;
                                return <th key={index}>{s.toUpperCase()}</th>;
                              })}
                              {/* <th></th> */}
                              <th>
                                <FullscreenIcon
                                  onClick={() => setExpandfollowupmodal(true)}
                                  style={{ cursor: "pointer" }}
                                />
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ whiteSpace: "nowrap", cursor: "pointer" }}>
                            {updateheaderrow.map((s, index) => {
                              const keys = updatekeys;
                              return (
                                <tr key={index} style={{ cursor: "pointer" }}>
                                  {keys.map((data, key) => {
                                    if (s[data] == null) s[data] = "";
                                    if (data === "omit" || data === "followupid") return null;
                                    if (data === "remarks") {
                                      return (
                                        <td
                                          key={key}
                                          style={{
                                            whiteSpace: "normal",
                                            textDecoration: s["omit"] == 1 ? "line-through" : undefined,
                                          }}
                                          dangerouslySetInnerHTML={{ __html: s[data] }}
                                        />
                                      );
                                    }
                                    if (typeof s[data] !== "object") {
                                      return (
                                        <td
                                          key={key}
                                          style={{
                                            textDecoration: s["omit"] == 1 ? "line-through" : undefined,
                                          }}
                                          dangerouslySetInnerHTML={{ __html: s[data] }}
                                        />
                                      );
                                    }
                                    return null;
                                  })}
                                 
                                  <td></td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-1">
                      <button
                        className="btn-primary margin-btt"
                        onClick={() => handlePrevious()}
                        disabled={isdisable || currentindex === 0}
                      >
                        <GrPrevious className="icon-btt" />
                      </button>
                    </div>
                    <div className="col-11" style={{ paddingRight: "0px" }}>
                      <div className="container-fulid" style={{ padding: "0px" }}></div>
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "30%" }}>
                                              <div
  style={{
    width: "18px",
    height: "18px",
    display: "inline-block",
    marginTop: "4px",
    backgroundColor:
     statusdata == 1
        ? "#22c55e" 
        : statusdata == 2
        ? "#facc15" 
        : statusdata == 3
        ? "red" 
        : "#9ca3af", 
  }}
></div>{" "}
                          <span dangerouslySetInnerHTML={{ __html: snewdata || null }} />
                          <br />
                          {/* <span style={{ fontWeight: "bold", textTransform: "uppercase" }}>
                            Chances
                          </span>{" "}
                          :{" "}
                          <span dangerouslySetInnerHTML={{ __html: chances || null }} /> */}
                          
                          {labelupdate.map((s, index) => (
                            <React.Fragment key={index}>
                              <span style={{ fontWeight: "bold", textTransform: "uppercase" }}>
                                {s.name}
                              </span>{" "}
                              :{" "}
                              <span
                                
                                dangerouslySetInnerHTML={{ __html: s.value || null }}
                              />
                              <br />
                            </React.Fragment>
                          ))}
                        </div>
                       
                      </div>
                    </div>
                    <div className="col-1">
                      <button
                        className="btn-primary margin-btt"
                        disabled={
                          isdisable ||
                          openedFromToast ||
                          currentindex === cidarray.length - 1
                        }
                        onClick={() => handleNext()}
                      >
                        <GrNext className="icon-btt" />
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50vh",
                  }}
                >
                  <h3 style={{ fontFamily: "sans-serif", color: "#eea606" }}>
                    No Records!
                  </h3>
                </div>
              )
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  height: "50vh",
                  alignItems: "center",
                }}
              >
                <Spinner color="red" animation="border" variant="dark" />
              </div>
            )}
          </Modal.Body>
        </Modal>
      )}

      {expandfollowupmodal && (
        <Modal
          centered
          show={expandfollowupmodal}
          onHide={() => setExpandfollowupmodal(false)}
          fullscreen
        >
          <Modal.Header closeButton>
            <Modal.Title>Follow Ups</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ textAlign: "center" }}>
            <Table
              responsive
              className="table table-striped"
              style={{ marginBottom: "20px" }}
            >
              <thead scope="row" style={{ whiteSpace: "nowrap" }}>
                <tr
                  style={{
                    background: "rgb(18 80 172)",
                    color: "white",
                    position: "sticky",
                    top: "0px",
                  }}
                >
                  {updatekeys.map((s, index) => {
                    if (s === "omit" || s === "followupid") return null;
                    return <th key={index}>{s.toUpperCase()}</th>;
                  })}
                </tr>
              </thead>
              <tbody style={{ whiteSpace: "nowrap", cursor: "pointer" }}>
                {updateheaderrow.map((s, index) => {
                  const keys = updatekeys;
                  return (
                    <tr key={index} style={{ cursor: "pointer" }}>
                      {keys.map((data, key) => {
                        if (s[data] == null) s[data] = "";
                        if (data == "omit" || data == "followupid") return null;
                        if (data == "remarks") {
                          return (
                            <td
                              key={key}
                              style={{
                                whiteSpace: "normal",
                                textDecoration: s["omit"] == 1 ? "line-through" : undefined,
                              }}
                              dangerouslySetInnerHTML={{ __html: s[data] }}
                            />
                          );
                        }
                        if (typeof s[data] !== "object") {
                          return (
                            <td
                              key={key}
                              style={{
                                textDecoration: s["omit"] == 1 ? "line-through" : undefined,
                              }}
                              dangerouslySetInnerHTML={{ __html: s[data] }}
                            />
                          );
                        }
                        return null;
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Modal.Body>
        </Modal>
      )}

      {isfollowdelete && followupdata && (
        <Followupdelete
          show={isfollowdelete}
          hide={() => setIsfollowdelete(false)}
          followupdata={followupdata}
          ActionModal={() => {
            setRefresh(1);
            refreshRef.current = 1;
            refreshActionModal(recidRef.current);
          }}
          
          agentID={agentid}
        />
      )}

      {
        (openattachment && attachment) && (

          <ViewComponent agentID={agentid} passid={attachment} closeModal={() => setopenatachment(false)} isViewModalOpen={openattachment}/>
        )
      }

    <CustomerEnquiryform
  open={editmodalshow && !!recid}
  onClose={() => seteditmodalshow(false)}
  agentID={agentID}
  editid={recid}
  refreshActionModal={() => {
    setRefresh(1);
    refreshRef.current = 1;
    refreshActionModal(recidRef.current);
  }}
/>   
    </div>
  );
});

export default ActionModal;